import { render, staticRenderFns } from "./DeptModal.vue?vue&type=template&id=0c106cfb&"
import script from "./DeptModal.vue?vue&type=script&lang=js&"
export * from "./DeptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports